import clsx from "clsx";
import { ReactNode } from "react";

import { Button, ButtonProps } from "../button";

export type ModalFooterProps = {
  buttons?: (ButtonProps & { key?: string })[];
  loading?: boolean;
  start?: ReactNode;
};

export const ModalFooter = ({ buttons, loading, start }: ModalFooterProps) => (
  <div
    className={clsx(
      "relative flex flex-col items-stretch gap-small px-[1.6rem] py-[0.8rem]",
      "mobile:px-[2.4rem] mobile:flex-row mobile:items-center mobile:gap-medium mobile:h-[6.4rem] mobile:py-[1.2rem]",
      start ? "mobile:justify-between" : "mobile:justify-end",
    )}
  >
    {start}
    <div
      className={clsx(
        "flex flex-col items-stretch gap-small",
        "mobile:flex-row mobile:items-center mobile:justify-end mobile:gap-medium",
        "[&>button]:w-full mobile:[&>button]:w-auto",
      )}
    >
      {buttons?.map((buttonProps) => (
        <Button key={buttonProps.key || buttonProps.text} {...buttonProps} />
      ))}
    </div>
    {loading && <div className="absolute inset-0 cursor-wait" />}
  </div>
);
